import { Typography, Button } from 'components'

type Props = {
	handleOpenAddMemberModal: () => void
}

const AdquireAdditionalSeatButton = ({ handleOpenAddMemberModal }: Props) => (
	<div class='rounded-md border border-black-800 bg-black-850 p-5'>
		<Typography
			color='text-black-100'
			text='Members'
			variant='h5'
			weight='font-bold'
		/>
		<Typography
			class='mb-5 mt-2'
			color='text-black-200'
			text="Acquiring seats enhances your team's collaboration and access within the organization."
			variant='text3'
		/>

		<Button
			onClick={handleOpenAddMemberModal}
			text='Acquire additional seat'
			variant='secondary'
			fullWidth
		/>
	</div>
)

export { AdquireAdditionalSeatButton }
